/**
 * Conversion interstitial — nudges the user to install the native app.
 * White execute shell + FloatingFooter (Back + Get X9).
 */
import X9Logo from '../components/X9Logo';
import FloatingFooter, {
  FloatingFooterCta,
  FloatingFooterNavButton,
} from '../components/FloatingFooter';

interface Props {
  onBack: () => void;
}

const PERKS = [
  'Reassign tasks to your contacts',
  'Create and manage your own tasks',
  'See all tasks assigned to you in one place',
  'Organize tasks into buckets with QR codes',
];

export default function ConvertStep({ onBack }: Props) {
  return (
    <div className="page-shell">
      <header className="page-header !pb-1">
        <span className="text-[10px] font-medium uppercase tracking-[0.2em] text-x9-marineSoft">
          Get X9
        </span>
      </header>

      <div className="page-body text-center">
        <div className="mx-auto flex w-[min(17vw,4.2rem)] flex-col items-center text-x9-marine">
          <X9Logo title="X9" className="block w-full select-none" />
        </div>

        <h1 className="mt-7 text-[28px] font-bold tracking-tight text-x9-ink">
          Get the full X9 experience
        </h1>
        <p className="mx-auto mt-3 max-w-sm text-sm leading-relaxed text-x9-marineSoft">
          Install the X9 app to unlock everything you can&rsquo;t do from a
          shared task link:
        </p>

        <ul className="mx-auto mt-6 max-w-sm space-y-3 text-left text-sm text-x9-ink">
          {PERKS.map((perk) => (
            <li key={perk} className="flex items-start gap-3">
              <span
                aria-hidden="true"
                className="mt-2 size-1.5 shrink-0 rounded-full bg-x9-marine/35"
              />
              <span>{perk}</span>
            </li>
          ))}
        </ul>
      </div>

      <FloatingFooter>
        <FloatingFooterNavButton label="Back" onClick={onBack} />
        <FloatingFooterCta
          onClick={() => {
            window.open('https://x9.app', '_blank', 'noopener,noreferrer');
          }}
        >
          Get X9 app
        </FloatingFooterCta>
      </FloatingFooter>
    </div>
  );
}
